import { capitalizeFirstLetter } from './capitalizeFirstLetter';

export async function pushNotificationMessage({ actionType, notifyContent, lang }) {

    const supportedLang = ['en', 'es', 'it', 'fr', 'pt', 'ar', 'he'];
    const requestLang = supportedLang.includes(lang) ? lang : 'en';

    const translationMessage = {
        newEnquiry: {
            en: {
                title: `New Enquiry`,
                message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
            },
        },
        declined: {
            en: {
                title: `Declined`,
                message: `${formatText(notifyContent['userName'])}: Booking is Declined`
            },
        },
        approved: {
            en: {
                title: `Approved`,
                message: `${formatText(notifyContent['userName'])}: Booking is Approved`
            },
        },
        newMessage: {
            en: {
                title: `New Message`,
                message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
            },
        },
        cancelReservation: {
            en: {
                title: `Booking is Cancelled`,
                message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
            },
        },
        newBooking: {
            en: {
                title: `New Booking`,
                message: `${formatText(notifyContent['userName'])}: ${notifyContent['messageContent']}`
            },
        },
        preApprove: {
            en: {
                title: `New Booking`,
                message: `${formatText(notifyContent['userName'])}: Your request is pre-approved`
            },
        },
        listApproved: {
            en: {
                title: `Admin has verified your listing`,
                message: `${formatText(notifyContent['userName'])} : Admin has verified your listing ${notifyContent['listTitle']} . Please publish your listing to get reservations.`
            },
        },
        listDeclined: {
            en: {
                title: `Admin has declined your listing`,
                message: `${formatText(notifyContent['userName'])} : Admin has declined your listing request for the ${notifyContent['listTitle']} due to the reason of ${notifyContent['reason']}. Kindly update the listing information and submit for the list approval.`
            },
        }
    }

    const translation = translationMessage[actionType][requestLang] || { title: '', message: '' };
    return {
        title: translation.title,
        message: translation.message
    };

}

export function formatAmount(amount, currency, locale) {
    let convertCurrency = 'USD';
    if (amount) {
        convertCurrency = currency ? currency : convertCurrency;
        return amount.toLocaleString(locale, { style: 'currency', currency: convertCurrency });
    } else {
        return null;
    }
}

export function formatText(text) {
    let capitalizedText = capitalizeFirstLetter(text);
    return capitalizedText ? capitalizedText.trim() : '';
}